import { render, staticRenderFns } from "./new-template.vue?vue&type=template&id=c524b80e"
import script from "./new-template.vue?vue&type=script&lang=js"
export * from "./new-template.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports